<script>
import {mapState} from "pinia";
import {Store} from "../stores/store";

export default {
    computed: {
        ...mapState(Store, ['permissions']),
    },
    methods: {
        hasPermission(name) {
            if (!Array.isArray(this.permissions)) {
                return false;
            }
            return this.permissions.some(permission => permission && permission.name === name);
        },
    }
}
</script>
